import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IAppState } from 'config/redux/reducers';
import { IAddress } from 'services/user/types/user.types';
import { IValidateCart } from 'pages/Checkout/types/validateCart.types';
import { validateCartEntries } from 'pages/Checkout/redux/actions/validateCart.actions';

const useValidateCart = (): [
  IValidateCart,
  { onValidateCartEntriesHandler: (address: IAddress) => any }
] => {
  const dispatch = useDispatch();
  const validateCartState = useSelector(
    ({ checkout: { delivery } }: IAppState) => delivery.validateCart
  );

  const onValidateCartEntriesHandler = useCallback(
    (address: IAddress) => dispatch(validateCartEntries(address)),
    [dispatch]
  );
  return [validateCartState, { onValidateCartEntriesHandler }];
};

export default useValidateCart;
